import React from "react";
import "./App.css";
import Home from "./pages/Home";
import {Route, Routes} from "react-router-dom";
import SingleApiPage from "./pages/SingleApiPage";
import "./stylesheets/screen.css.scss";
import "./stylesheets/print.css.scss";
import NavBar from "./components/NavBar";
import GetStarted from "./pages/GetStarted";
import {MyContextProvider} from "./context/MyContext";
import ApiDetailsPage from "./pages/ApiDetailsPage";
import ContactUs from "./components/ContactUs";
import HealthCheck from "./HealthCheck";
import {Helmet} from "react-helmet";

const App =() =>{
  return (
    <MyContextProvider>
      <Helmet>
        <title>Phenom API Documentation</title>
      </Helmet>
      <div className="App">
        <NavBar/>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/" element={<SideWrapper />}></Route> */}
          {/* <Route path="/api/*" element={<ApiDetail />} /> */}
          <Route path={"/card/:id"} element={<SingleApiPage/>} />
          <Route path={"/getStarted"} element={<GetStarted/>}/>
          <Route path="/apiDetail" element={<ApiDetailsPage/>}/>
          <Route path="/ContactUs" element={<ContactUs/>}/>
          <Route path= "/health" element={<HealthCheck/>}/>
          <Route path= "/card/:id#:method" element={< SingleApiPage/>}/>
        </Routes>
      </div>
    </MyContextProvider>
  );
};

export default App;
